import React from "react";
import ChatBox from "./components/ChatBox";

function App() {
  return <ChatBox />;
}

export default App;


